import { Translate } from 'react-redux-i18n'
import Time, { getDateTime } from 'components/time'
import { hasPermissionFor } from 'components/guard'
import DownloadBtn from 'components/download-btn'
import Dashboard from 'endpoints/dashboard'

const FileInfo = ({ file, type }) => (
  <dl className="row m-0">
    <dt className="col-12 col-md-2 pl-0">
      <Translate value={`home.step_file.file_types.${type}`} />:
    </dt>
    <dd className="col">
      {file.name}
      <p className="m-0">
        <label className="m-0 mr-1 text-muted"><Translate value="home.step_file.uploaded_at" />:</label>
        <Time value={file.createdAt} />
      </p>
    </dd>
  </dl>
);

export default class extends React.Component {
  constructor() {
    super();
    this.state = { showDetails: false, uploadError: false, uploadStatus: null };
    this.restoreFile = this.restoreFile.bind(this);
    this.openDetails = this.openDetails.bind(this);
    this.closeDetails = this.closeDetails.bind(this);
  }

  componentDidMount() {
    this.fileNode.addEventListener('change', () => {
      let file = this.fileNode.files[0];
      if(file) {
        this.setState({ uploadError: false, uploadStatus: 0 });
        Dashboard.uploadDraftFile(this.props.id, file, uploadStatus => this.setState({ uploadStatus })).then(
          () => this.setState({ uploadStatus: null }),
          () => this.setState({ uploadError: true, uploadStatus: null })
        );
        this.fileNode.value = '';
      }
    });
  }

  restoreFile(e) {
    e.preventDefault();
    Dashboard.deleteDraftFile(this.props.id).then(() => this.setState({ showDetails: false }));
  }

  openDetails(e) {
    e.preventDefault();
    this.setState({ showDetails: true });
  }

  closeDetails(e) {
    e.preventDefault();
    this.setState({ showDetails: false });
  }

  render() {
    let { draftFile, releaseFile, id } = this.props;
    let readDisabled = this.props.disabled || !hasPermissionFor(draftFile.type, 'read');
    let writeDisabled = this.props.disabled || !hasPermissionFor(draftFile.type, 'write');

    if(this.state.showDetails) {
      let draftFileInfo;
      if(draftFile) {
        draftFileInfo = (<FileInfo file={draftFile} type="draft" />);
      }

      let releaseFileInfo;
      if(releaseFile) {
        releaseFileInfo = (<FileInfo file={releaseFile} type="release" />);
      }
      return (
        <div className="step-file">
          <div className="step-file_affix">
            <a className="step-file_close" onClick={this.closeDetails} href="#" />
          </div>
          <div className="step-file_body">
            {draftFileInfo}
            {releaseFileInfo}
          </div>
          <div className="step-file_btns">
            <button type="button" onClick={this.restoreFile} className="step-file_btn step-file_btn--restore" disabled={writeDisabled || !draftFile}>
              <Translate value="home.step_file.btns.restore" />
            </button>
          </div>
        </div>
      );
    } else {
      let fileStatus;

      let stepStatus = draftFile ?
        (<span className={`status-icon status-icon--${draftFile.status.toLowerCase()}`} />) :
        (<span className={`status-icon status-icon--${releaseFile.status.toLowerCase()}`} />);

      if(this.state.uploadError) {
        fileStatus = (<Translate value="home.step_file.file_status.upload_error" className="text-danger" />);
      } else if(draftFile) {
        fileStatus = (<Translate value="home.step_file.file_status.draft_file" uploadedAt={getDateTime(draftFile.createdAt)} />);
      } else {
        fileStatus = (<Translate value="home.step_file.file_status.release_file" uploadedAt={getDateTime(releaseFile.createdAt)} />);
      }

      let uploadHover;
      if(this.state.uploadStatus !== null) {
        uploadHover = (
          <div className="step-file_upload">
            <h3 className="text-uppercase text-center"><Translate value="home.step_file.uploading" /></h3>
            <div className="step-file_upload_bar" style={{ maxWidth: `${this.state.uploadStatus}%` }} />
          </div>
        );
      }

      return (
        <div className="step-file">
          <div className="step-file_affix">{stepStatus}</div>
          <div className="step-file_body">
            <a className="step-file_title" onClick={this.openDetails} href="#">
              <Translate value={`enums.permission.${id.toLowerCase()}`} />
            </a>
            <dl className="row m-0">
              <dt className="col-12 col-md-2 pl-0"><Translate value="home.step_file.file_status.title" />:</dt>
              <dd className="col">{fileStatus}</dd>
            </dl>
            <dl className="row m-0">
              <dt className="col-12 col-md-2 pl-0"><Translate value="home.step_file.data_check.title" />:</dt>
              <dd className="col"><Translate value="home.step_file.data_check.start_check" /></dd>
            </dl>
          </div>
          <div className="step-file_btns">
            <label className={`step-file_btn step-file_btn--upload step-file_btn--${writeDisabled ? 'disabled' : 'active'}`}>
              <Translate value="home.step_file.btns.upload" />
              <input type="file" accept={draftFile.extName} ref={node => this.fileNode = node} disabled={writeDisabled} />
            </label>
            <DownloadBtn
              type="dashboard"
              id={this.props.id}
              disabled={readDisabled}
              className="step-file_btn step-file_btn--download"
            >
              <Translate value="home.step_file.btns.download" />
            </DownloadBtn>
          </div>
          {this.props.prefixBtn ? <div className="step-file_prefix">{this.props.prefixBtn}</div> : null}
          {uploadHover}
        </div>
      );
    }
  }
}
